import React, { useState } from 'react';
import { Settings, Globe } from 'lucide-react';
import GoogleMapScreenWithGeocercaControls from './GoogleMapScreenWithGeocercaControls';
import GestionGeocercas from './GestionGeocercas';
import { GoogleMapsProvider } from '../../context/GoogleMapsContext';

interface MapaCompletoProps {
  token: string;
}

const MapaCompleto: React.FC<MapaCompletoProps> = ({ token }) => {
  const [activeTab, setActiveTab] = useState<'google' | 'geocercas'>('google');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleGeocercaCreated = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <GoogleMapsProvider>
      <div className="h-screen flex flex-col">
        {/* Tabs */}
        <div className="bg-white border-b border-gray-200">
          <div className="flex">
            <button
              onClick={() => setActiveTab('google')}
              className={`flex items-center gap-2 px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
                activeTab === 'google'
                  ? 'border-blue-500 text-blue-600 bg-blue-50'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Globe size={20} />
              Google Maps con Controles
            </button>
            <button
              onClick={() => setActiveTab('geocercas')}
              className={`flex items-center gap-2 px-6 py-3 font-medium text-sm border-b-2 transition-colors ${
                activeTab === 'geocercas'
                  ? 'border-blue-500 text-blue-600 bg-blue-50'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Settings size={20} />
              Gestión de Geocercas
            </button>
          </div>
        </div>

        {/* Contenido */}
        <div className="flex-1">
          {activeTab === 'google' && (
            <GoogleMapScreenWithGeocercaControls key={`google-${refreshKey}`} token={token} />
          )}
          {activeTab === 'geocercas' && (
            <GestionGeocercas token={token} onGeocercaCreated={handleGeocercaCreated} />
          )}
        </div>
      </div>
    </GoogleMapsProvider>
  );
};

export default MapaCompleto;
